import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../../styles/entity-scores-widget-group.module.scss";

export class EntityScoresGroupListTitleProps extends BaseProps {}

export const EntityScoresWidgetGroupsTitle = observer(({
                                             controller,
                                             isLive,
                                             shouldRenderTitle
                                           }: EntityScoresGroupListTitleProps) => {
  const {state, terms} = controller;
  const {WEB_LIVE_SEPARATOR} = terms;
  const {entityContext: {sectionSubtitle}} = state;
  const title: String = isLive ? WEB_LIVE_SEPARATOR : sectionSubtitle;

  return shouldRenderTitle ? <div className={classNames(styles.title, {[styles.live_title]: isLive})}>{title}</div> : null;
});
